import React from 'react';

export const shotAlt = (shot) => {
  const parts = [shot.title, shot.location].filter(Boolean);
  return parts.length > 0 ? parts.join(', ') : 'Drone photograph';
};

const COORDS_RE = /^(-?\d{1,3}\.\d{4}), (-?\d{1,3}\.\d{4})$/;

// Raw coordinates are never shown; the stored "lat, lon" becomes a Google Maps Search URL.
// Only the canonical four-decimal "lat, lon" the API stores, within range, forms a link;
// anything else (legacy or malformed data) yields null, so no link is built from it.
export const mapsUrl = (coords) => {
  const m = typeof coords === 'string' ? COORDS_RE.exec(coords) : null;
  if (!m || Math.abs(Number(m[1])) > 90 || Math.abs(Number(m[2])) > 180) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${m[1]},${m[2]}`)}`;
};

// GPS link, capture date and camera for one shot. Missing values show "-". No file name.
const ShotMeta = ({ shot }) => {
  const href = mapsUrl(shot.coords);
  return (
    <dl className="kv kv-tight shot-meta">
      <div className="kv-row">
        <dt>gps</dt>
        <dd>
          {href ? (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`View on Google Maps: ${shotAlt(shot)} (opens in a new tab)`}
            >
              View on Google Maps
            </a>
          ) : (
            '-'
          )}
        </dd>
      </div>
      <div className="kv-row">
        <dt>taken</dt>
        <dd>{shot.taken || '-'}</dd>
      </div>
      <div className="kv-row">
        <dt>cam</dt>
        <dd>{shot.camera || '-'}</dd>
      </div>
    </dl>
  );
};

export default ShotMeta;
